<div class="container">
  <div>
    <div class="col-lg-4 col-md-4 col-sm-6">
      <app-figurecard
        [title]="productCount"
        headerIcon="store"
        category="Product"
        footContent="Active Products"
        linearColor="linear-gradient(60deg, #ef5350, #e53935)"
        boxShadow="0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(244, 67, 54, 0.4)"
        (click)="showProducts()"
        (keydown.enter)="showProducts()"
        (keydown.space)="showProducts()"
      ></app-figurecard>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6">
      <app-figurecard
        [title]="categoryCount"
        headerIcon="devices"
        category="Categories"
        footContent="Active Product Categories"
        linearColor="linear-gradient(60deg, #66bb6a, #43a047)"
        boxShadow="0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(76, 175, 80, 0.4)"
        (click)="showCategories()"
        (keydown.enter)="showCategories()"
        (keydown.space)="showCategories()"
      ></app-figurecard>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6">
      <app-figurecard
        [title]="subcategoryCount"
        headerIcon="dvr"
        category="SubCategories"
        footContent="Active Product Sub-categories"
        linearColor="linear-gradient(60deg, #26c6da, #00acc1)"
        boxShadow="0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(0, 188, 212, 0.4)"
        (click)="showSubCategories()"
        (keydown.enter)="showCategories()"
        (keydown.space)="showCategories()"
      ></app-figurecard>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6">
      <app-figurecard
        [title]="dataCenterCount"
        headerIcon="warehouse"
        category="Datacenters"
        footContent="Active Datacenters"
        linearColor="linear-gradient(60deg, #26c6da, #00acc1)"
        boxShadow="0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(0, 188, 212, 0.4)"
        (click)="showDatacenters()"
        (keydown.enter)="showDatacenters()"
        (keydown.space)="showDatacenters()"
      ></app-figurecard>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6">
      <app-figurecard
        [title]="userCount"
        headerIcon="supervised_user_circle"
        category="Admin Users"
        footContent="Current Active Admin Users"
        linearColor="linear-gradient(60deg, #ffa726, #fb8c00)"
        boxShadow="0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(255, 152, 0, 0.4)"
        (click)="showUsers()"
        (keydown.enter)="showUsers()"
        (keydown.space)="showUsers()"
      ></app-figurecard>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6">
      <app-figurecard
        [title]="assetUserCount"
        headerIcon="supervised_user_circle"
        category="Asset Users"
        footContent="Current Active Asset Users"
       linearColor="linear-gradient(60deg, #90a4ae, #78909c)"
        boxShadow="0 4px 20px 0 rgba(0,0,0,0.14), 0 7px 10px -5px rgba(120, 144, 156, 0.4)"
        (click)="showAssetUsers()"
        (keydown.enter)="showAssetUsers()"
        (keydown.space)="showAssetUsers()"
      ></app-figurecard>
    </div>
  </div>
  <div *ngIf="isLoaderResult" class="custSpinner"></div>
</div>
